import * as nicknameGen from "@axvdex/solana/nicknameAPI/js/src/generated";

export enum ActionType {
  InitSetOwnNickname,
  OverrideOwnNickname,
  OverrideOwnNicknameByOther,
  GetOwnProtection,
  InitSetOtherNickname,
  OverrideOtherNickname,
}

export function nicknameActionToEnum(action: nicknameGen.ActionType): number {
  if (action === nicknameGen.ActionType.InitSetOwnNickname) {
    return 0;
  } else if (action === nicknameGen.ActionType.OverrideOwnNickname) {
    return 1;
  } else if (action === nicknameGen.ActionType.OverrideOwnNicknameByOther) {
    return 2;
  } else if (action === nicknameGen.ActionType.GetOwnProtection) {
    return 3;
  } else if (action === nicknameGen.ActionType.InitSetOtherNickname) {
    return 4;
  } else if (action === nicknameGen.ActionType.OverrideOtherNickname) {
    return 5;
  }
}

export type NicknameInfo = nicknameGen.NicknameInfo & {
  hasChangedSomeoneElse: boolean;
};
